// 403
export const imcIcon403 = 'https://image1.guazistatic.com/qn2008211507446e50ebd35ffd191bda772c3f237a7644.png'
// 404
export const imcIcon404 = 'https://image.guazistatic.com/gz01200425/14/51/26eac14a6d600bc15eb2b7ae3f85bf43.png'
// 500
export const imcIcon500 = 'https://image.guazistatic.com/gz01200425/14/51/5fcee5ef6185dbb4d3ea663a4ec30967.png'
// 系统维护中
export const imcIconMaintenance = 'https://image.guazistatic.com/gz01200416/18/25/5923bcaa69f665e7944053e0044d6b19.png'
